<template>
	<div class="row">
		<div class="form-group col-md-2">
			<label for="filter_text">Empresa</label>
			<select class="form-select form-select-sm" v-model="enterprise_id" @change="mtd_filter">
				<option value="">Todas</option>
				<option :value="item.id" v-for="(item, index) in enterprises" :key="index">{{ item.denomination }}</option>
			</select>
		</div>
		<div class="form-group col-md-2">
			<label for="filter_text">Estado</label>
			<select class="form-select form-select-sm" v-model="state" @change="mtd_filter">
				<option value="1">Activo</option>
				<option value="0">No activo</option>
				<option value="">Todas</option>
			</select>
		</div>
		<div class="form-group col-md-3">
			<label for="filter_text">Buscar</label>
			<div class="input-group">
				<input v-model="text" @keypress.enter="mtd_filter" class="form-control form-control-sm" id="filter_text" type="text" />
				<button style="border-bottom-left-radius: 0; border-top-left-radius: 0" @click="mtd_filter" class="btn btn-primary btn-xs">Filtrar</button>
			</div>
		</div>
	</div>
</template>
<script>
/** Vuex */
import { mapActions, mapGetters } from 'vuex';
export default {
	props: ['prop-execute', 'page'],
	data() {
		return {
			text: '',
			enterprises: [],
			enterprise_id: '',
			state: 1,
		};
	},
	created() {
		this.mtd_getFilters();
		this.mtd_executeFilter('new');
	},
	computed: {
		...mapGetters(['url_api']),
	},
	watch: {
		propExecute: function (newValue) {
			if (newValue) this.mtd_executeFilter();
		},
		page: function (newValue) {
			if (newValue) this.mtd_executeFilter();
		},
	},
	methods: {
		...mapActions(['get', 'post', 'get_sin_bus', 'execute_commit']),
		mtd_getFilters: function () {
			this.get({
				url: this.url_api + '/campus/index/filters',
			})
				.then(response => {
					this.enterprises = response.enterprises;
				})
				.catch(() => {});
		},
		mtd_filter: function () {
			this.mtd_executeFilter('new');
			this.$emit('emit-init-pagination');
		},
		mtd_executeFilter: function (type = null) {
			let pagination = null;
			type == 'new' ? (pagination = 1) : (pagination = this.page);

			const params = {
				url: `${this.url_api}/campus?&page=${pagination}&text=${this.text}&enterprise_id=${this.enterprise_id}&state=${this.state}`,
				mutation: 'CAMPUS_INDEX__SET_ALL',
			};
			this.get(params);
		},
	},
};
</script>
